import React, { useState, useEffect } from 'react';
import Styles from './Announcement.module.scss';
import { ReactComponent as AnnouncementIcon } from '../../../assets/svg/Announcement.svg';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Change this version number to make the banner reappear for all users
const ANNOUNCEMENT_VERSION = "v4";
const STORAGE_KEY = `announcementDismissed_${ANNOUNCEMENT_VERSION}`;

const Announcement = ({ view = false }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);
  
  // Get user data from Redux store
  const { user } = useSelector((state) => state.auth);
  const hasBrands = user?.user_brands?.brands_count > 0;
  
  // Check if the announcement was previously dismissed or if user has brands
  useEffect(() => {
    const isDismissed = localStorage.getItem(STORAGE_KEY);
    if (isDismissed === 'true' || hasBrands) {
      setIsVisible(false);
    }
  }, [hasBrands]);

  const handleDismiss = () => {
    setIsVisible(false);
    // Save the dismissed state to localStorage
    localStorage.setItem(STORAGE_KEY, 'true');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={Styles.container}>
      <div className={Styles.container__left}>
        <div className={Styles.container__left__icon}>
          <AnnouncementIcon />
        </div>
        <div className={Styles.container__left__body}>
          <span className={Styles.container__left__heading}>
            Brand Identity!
          </span>
          <span className={Styles.container__left__desc}>
            Set up your brand identity under 'Brand' Tab to build the foundation for all your AI-generated content strategies.
          </span>
        </div>
      </div>
      <div className={Styles.container__right}>
        {view && (
          <button
            onClick={() => navigate('/brand')}
            className={Styles.actionButton}
          >
            Add Your Brand
          </button>
        )}
        <button
          onClick={handleDismiss}
          className={Styles.closeButton}
          aria-label="Dismiss announcement"
        >
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 1L1 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M1 1L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Announcement;